<template>
  <el-upload
    v-bind="$attrs"
    v-on="$listeners"
    accept="image/*"
    :action="uploadURL"
    :show-file-list="false"
    :before-upload="handleUploadBefore"
    :on-exceed="handleUploadExceed"
    :on-error="handleUploadError"
    :on-success="handleUploadSuccess"
  >
    <el-button :size="size" :type="type" :plain="plain" :loading="uploadLoading">
      <slot>
        <i class="el-icon-upload"></i>
        <span>点击上传</span>
      </slot>
    </el-button>
  </el-upload>
</template>
<script>
export default {
  name: 'FormUploadButton',
  props: {
    // 文件URL
    url: {
      type: [String, Array],
    },
    // 按钮尺寸
    size: {
      type: String,
      default: 'small',
    },
    // 按钮类型
    type: {
      type: String,
      default: '',
    },
    // 是否是朴素按钮
    plain: Boolean,
  },
  data() {
    return {
      uploadURL: '/media/v1/upload2', // 上传地址
      uploadLoading: false, // 图片上传状态
    };
  },
  methods: {
    // 图片上传之前
    handleUploadBefore() {
      this.uploadLoading = true;
    },
    // 图片上传超出限制
    handleUploadExceed(files, uploadFileList) {
      this.$warning(
        `最多上传 ${this.$props.limit} 张图片，本次选择了 ${files.length} 张图片，总共选择了 ${files.length +
          uploadFileList.length} 张图片`,
      );
    },
    // 图片上传成功
    handleUploadSuccess(response) {
      this.uploadLoading = false;
      if (this.$props.multiple === true) {
        this.$emit('update:url', response.data);
      } else {
        this.$emit('update:url', response.data[0]);
      }
    },
    // 图片上传失败
    handleUploadError() {
      this.uploadLoading = false;
    },
  },
};
</script>
